(function ($) {
  'use strict';

  function MainNav () {
  }

  MainNav.prototype = {

    /*
     * Start with init Function
     */
    init: function () {
      this.$toggle = $('.js-main-nav-toggle');
      this.$menu = $('.js-main-nav-menu');

      // If the window width determines we don't show the full nav, remove the is-active class
      if (window.Framework.windowWidth.ww < window.Framework.CONSTANTS.MQ.small) {
        this.$toggle.removeClass('is-active');
        this.$menu.removeClass('is-active');
      }

      this.$toggle.on('click', $.proxy(this.onMenuToggleClick, this));
    },

    onMenuToggleClick: function (e) {
      e.preventDefault();

      this.$toggle.toggleClass('is-active');
      this.$menu.toggleClass('is-active');
    }
  };

  this.MainNav = MainNav;
}).call(Framework, jQuery);
